var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21,19.7l-2.2,1.8l3-1.5v-0.2c0,0-0.1-0.1-0.1-0.1C21.5,19.5,21.2,19.5,21,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.4,37.5h6.9c1.9,0,3.4-1.5,3.4-3.4v-14c0-1.9-1.5-3.4-3.4-3.5h-0.5v-2.3c-0.1-0.9-0.8-1.6-1.7-1.6h-0.3 v-1.3h0.3V7.5h-2.6v0.7h-9.8v2.2h2V9.8h7.8v1.6h0.4v1.3h-0.4c-0.9,0-1.6,0.7-1.6,1.6v2.3h-0.5c-1.9,0.1-3.4,1.6-3.4,3.5v14 C25,36,26.5,37.5,28.4,37.5z M32.5,8.2v2.6h-1.3V8.2H32.5z M30.5,9.1h-8.4v0.7h-0.7v-1h9.1V9.1z M31.5,11.4h0.7v1.3h-0.7V11.4z  M25.6,20.1c0-1.5,1.3-2.8,2.8-2.8h6.9c1.5,0,2.7,1.2,2.7,2.7c0,0,0,0.1,0,0.1v14c0,1.5-1.2,2.7-2.7,2.7h-6.9 c-1.5,0-2.7-1.2-2.8-2.7V20.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 8.2,
    fill: "#A1A1A1",
    width: 1.3,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "21.4,8.8 21.4,9.8 22.1,9.8 22.1,9.1 30.5,9.1 30.5,8.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 11.4,
    fill: "#C9C9C9",
    width: 0.7,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.4,36.8h6.9c1.5,0,2.7-1.2,2.7-2.7v-14c0,0,0-0.1,0-0.1c0-1.5-1.2-2.7-2.7-2.7h-6.9 c-1.5,0-2.8,1.3-2.8,2.8v14C25.7,35.6,26.9,36.8,28.4,36.8z M37.1,33.6c-0.1,1.2-1.1,2.2-2.3,2.3h-2.3v-0.7h2.3 c0.9,0,1.6-0.7,1.6-1.6v-5.9h0.7V33.6z M37.1,22.5h-0.7v-2c0-0.9-0.7-1.6-1.6-1.6h-5.2v-0.6h5.2c1.2,0,2.2,1,2.3,2.2V22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M21.5,10.9c-0.8,0-2.4,4.1-2.4,5.1c0.3,1.4,1.6,2.2,2.9,2c1-0.2,1.8-1,2-2C24,15,22.3,10.9,21.5,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.3,25.7l0.2,0.7c1.5-0.5,3-0.8,4.5-0.8c1.1-0.1,2.3,0.1,3.4,0.4c0.6,0.1,1.2,0.1,1.7-0.2 c2-0.9,5.3-2.6,7.2-3.7c1.9-1.1,1.2-1.4,0.9-1.9c-0.4-0.5-1.1-0.8-1.7-0.5l-0.2-0.3c-0.2-0.3-0.6-0.5-1-0.5c-0.3,0-0.5,0.1-0.7,0.3 L18.3,21c-0.2-0.3-0.6-0.4-0.9-0.4h-2.3c-0.6,0-1.2-0.2-1.8-0.4c-0.7-0.2-1.4-0.4-2.1-0.4c-1,0-2,0.3-2.8,0.8l-2.1,0.9l0.2,0.6 c0.8-0.3,1.5-0.6,2.2-0.9c0.7-0.5,1.6-0.7,2.5-0.7c0.6,0,1.3,0.1,1.9,0.3c0.6,0.2,1.3,0.4,2,0.4h2.3c0.3,0,0.5,0.3,0.6,0.6 c-0.1,0.4-0.4,0.7-0.8,0.7h-5.4v0.7h5.4c0.6,0,1.1-0.4,1.3-0.9l4.3-2c0.3-0.2,0.6-0.1,0.8,0.2c0.2,0.4,0,0.7-0.6,1.1 c-2.3,1.3-4.7,2.5-7.1,3.6c-0.4,0.2-0.9,0.3-1.4,0.1C13.3,25.1,12.2,25,11,25C9.4,25,7.8,25.2,6.3,25.7z M21.8,20l-3,1.5l2.2-1.8 c0.2-0.2,0.5-0.2,0.7,0c0,0,0.1,0.1,0.1,0.1V20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M36.4,33.6c0,0.9-0.7,1.6-1.6,1.6h-2.3v0.7h2.3c1.2-0.1,2.2-1.1,2.3-2.3v-5.9h-0.7V33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M34.8,18.3h-5.2v0.6h5.2c0.9,0,1.6,0.7,1.6,1.6v2h0.7v-2C37,19.3,36,18.3,34.8,18.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoap);
export default __webpack_public_path__ + "static/media/soap.55c5434cd8a586c3788caca836258965.svg";
export { ForwardRef as ReactComponent };